import React, { useState } from 'react'
import './App.css'
import RequestDemoForm from './RequestDemoForm'
import { ErrorOutline } from '@mui/icons-material'

const Form = ({ productContent, product }) => {
  const [registerError, setRegisterError] = useState('')

  const showAlert = (errorMessage) => {
    setRegisterError(errorMessage)
  }

  return (
    <main>
      <div className='title' style={{ backgroundColor: productContent.titleBackgroundColor }}>
        <img src={productContent.background} className='mg-img-absolute' alt={product} />
      </div>
      <div className='two-column-wrapper'>
        <section>
          <div className='mg-live-session'>
            <img className='mg-logo' src={productContent.logo} alt={product} />
            <p className='live-session'>{productContent.moto}</p>
          </div>
          <p>{productContent.description1}</p>
          <p>{productContent.description2}</p>
          {productContent.descriptionList && productContent.descriptionList.length > 0 && (
            <ul>
              {productContent.descriptionList.map((element, index) => (
                <li key={'list' + index}>{element}</li>
              ))}
            </ul>
          )}
          <video width='100%' height='auto' poster={productContent.poster} controls>
            <source src={productContent.video} />
          </video>
        </section>
        <section>
          <div className='form-wrapper'>
            {product === 'countersketch-trial' ? <h3>Request a 15-day trial</h3> : <h3>Registration Form</h3>}
            <RequestDemoForm product={product} buttonColor={productContent.buttonColor} showAlert={showAlert} />
            {registerError !== '' && (
              <div className='form-error'>
                <ErrorOutline />
                <p>{registerError}</p>
              </div>
            )}
          </div>
        </section>
      </div>
    </main>
  )
}

export default Form
